import React,{useMemo} from "react";
import { Card, CardBody } from "reactstrap";
import TermSavingsTableData from "./TermSavingsTableData";
import SubHeader from "../../Common/SubHeader";
import FilterHeader from "../../Common/FilterHeader";

const TERMS_OPTIONS = [
  { value: "", label: "All Terms" },
  { value: "1", label: "2 Hours" },
  { value: "30", label: "30 Days" },
  { value: "60", label: "60 Days" },
  { value: "90", label: "90 Days" },
  { value: "180", label: "180 Days" },
  { value: "365", label: "365 Days" },
];

const STATUS_OPTIONS = [
  { value: "", label: "All Status" },
  { value: "Started", label: "Started" },
  { value: "Finished", label: "Finished" },
  { value: "Canceled", label: "Cancelled" },
];

const fields = [
  { key: "firstName", label: "First Name", type: "text", placeholder: "e.g. John" },
  { key: "lastName", label: "Last Name", type: "text", placeholder: "e.g. Doe" },
  { key: "userId", label: "User ID", type: "text", placeholder: "e.g. 4000000000" },
  { key: "terms", label: "Term", type: "select", options: TERMS_OPTIONS },
  { key: "status", label: "Status", type: "select", options: STATUS_OPTIONS },
  { key: "createdAt", label: "Date Range", type: "daterange", colClass: "col-12 col-md-4 col-lg-2" },
];

const TermSavingsTable = ({
  data,
  isLoading,
  totalRows,
  currentPage,
  onSearch,
  onPageChange,
  onReset,
  onRefresh,
  activeFilters,
  limit,
}) => {
  const handleSearch = (currentFilters) => {
    const payload = {
      firstName: currentFilters.firstName,
      lastName: currentFilters.lastName,
      userId: currentFilters.userId,
      terms: currentFilters.terms,
      status: currentFilters.status,
      dateFrom: currentFilters.createdAtFrom,
      dateTo: currentFilters.createdAtTo,
    };
    onSearch(payload);
  };

  // Maps flat activeFilters back to the format FilterHeader expects
  const mappedInitialFilters = useMemo(() => ({
  ...activeFilters,
  createdAtFrom: activeFilters?.dateFrom,
  createdAtTo: activeFilters?.dateTo,
}), [activeFilters]);

  return (
    <>
      <SubHeader title="Term Savings" data={data} />

      <FilterHeader
        title="Filter Records"
        fields={fields}
        onSearch={handleSearch}
        onReset={onReset}
        onRefresh={onRefresh} 
        initialFilters={mappedInitialFilters}
      />

      <Card className="tranaction-card">
        <CardBody className="pt-4">
          <div className="show table-responsive recent-table transaction-table">
            <TermSavingsTableData
              data={data}
              isLoading={isLoading}
              totalRows={totalRows}
              currentPage={currentPage}
              onPageChange={onPageChange}
              limit={limit}
            />
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default TermSavingsTable;